import { useMemo } from 'react'
import { zeroPadding } from 'lib/helper'
import { SelectOption } from 'types/common'

const useTimesWithStartTime = (defaultStartTime: string, isStartTimeIncluded?: boolean): SelectOption[] => {
  return useMemo(() => {
    const _times: SelectOption[] = [{ label: '', value: '' }]
    let startHour = parseInt(defaultStartTime.split(':')[0], 10)
    let startTime = isStartTimeIncluded
      ? parseInt(defaultStartTime.split(':')[1], 10)
      : parseInt(defaultStartTime.split(':')[1], 10) + 15

    // デフォルトの開始時間が45分の場合、00を選べるようにする
    if (startTime === 60) {
      startHour += 1
      startTime = 0
    }

    for (let i = startHour; i < 24; i = (i + 1) | 0) {
      for (let j = startTime; j < 60; j = (j + 15) | 0) {
        // デフォルトの開始時刻をリセット
        if (startTime !== 0) startTime = 0
        const time = `${zeroPadding(i)}:${zeroPadding(j)}`
        _times.push({ label: time, value: time })
      }
    }

    return _times
  }, [defaultStartTime])
}

export default useTimesWithStartTime
